import { MissionTypeObjective } from "@/components/missions-render-v1/missions-render-types";
import TPremiaCard from "@/components/t-premia-card/t-premia-card";
import { extractHashtags } from "@/utils/string/extrac-hash";
import Tab1 from "./components/tab-1/tab-1";
import PostSuccessCard from "./components/post-success-card/post-success-card";
import { useObjectivePost } from "./hooks/useObjectivePost";
import { ObjectivePostType } from "./objective-post-types";

const ALLOWED_OBJECTIVES: MissionTypeObjective[] = ['MAKE_POST'];

const RenderAllowedObjective: React.FC<ObjectivePostType> = ({ 
  objective, 
  campaignId, 
  missionId, 
  participant, 
  getProgress, 
  isExpiredMission, 
  isComingSoon, 
  completedRequirements, 
  position, 
  loadingProgress,
  disabledMission
})=> {
  const { type, participant_progress, quantity } = objective;
  const { current_progress = 0, extra_progress_data } = participant_progress ?? {};
  const { post_url = '' } = extra_progress_data ?? {};
  const valuesType = type?.split(':');
  const idSM =  Number(String(valuesType?.[1]).split('_')?.[1]);
  const { description, details } = objective;
  const hashtags = extractHashtags(details?.template);
  const template = objective?.details?.template;
  const hookObjectivePost = useObjectivePost(idSM, campaignId, missionId, getProgress, post_url);
  const { postSaved } = hookObjectivePost;
  const isCompleted = postSaved && (current_progress > 0 && current_progress >= quantity) || post_url;
  if (isCompleted) {
    return (
      <PostSuccessCard 
        socialMediaSelected={hookObjectivePost?.socialMediaSelected} 
        urlPost={post_url || hookObjectivePost?.postSaved}
      />
    );
  }
  
  return (
    <TPremiaCard variant="dark" style={{ gap: '0px', padding: '0px', margin: '0px' }}>
      <Tab1 
        description={description} 
        hashtags={hashtags ?? []} 
        participant={participant} 
        template={template} 
        campaignId={campaignId}
        missionId={missionId}
        isExpiredMission={isExpiredMission}
        isComingSoon={isComingSoon}
        getProgress={getProgress}
        completedRequirements={completedRequirements}
        position={position}
        loadingProgress={loadingProgress}
        hookObjectivePost={hookObjectivePost}
        disabledMission={disabledMission}
      />
    </TPremiaCard>
  )
}

const ObjectivePost: React.FC<ObjectivePostType> = ({ objective, campaignId, missionId, participant, getProgress, isExpiredMission, isComingSoon, completedRequirements, position, loadingProgress, disabledMission }) => {
  const { type } = objective;
  const valuesType = type?.split(':');
  const objectiveType = valuesType?.[0] as MissionTypeObjective;

  if (!ALLOWED_OBJECTIVES.includes(objectiveType)) {
    return null;
  }
  return (
    <RenderAllowedObjective 
      objective={objective} 
      campaignId={campaignId} 
      missionId={missionId} 
      participant={participant} 
      getProgress={getProgress}
      isExpiredMission={isExpiredMission}
      isComingSoon={isComingSoon}
      completedRequirements={completedRequirements}
      position={position}
      loadingProgress={loadingProgress}
      disabledMission={disabledMission}
    />
  )
}

export default ObjectivePost;
